
// import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
// import './App.css';
// import Layout from './components/Layout/Layout';
// import Home from './components/Home/Home';
// import Registraction from './components/RegistrationPage/Registraction';
// import DashBoard from './components/DashBoard/DashBoard';
// import Login from './components/RegistrationPage/Login';
// import FetchData from './components/FetchData/FetchData';


// function App() {
//   const router = createBrowserRouter(
//     createRoutesFromElements(
//       <Route path='/' element={<Layout />}>
//         <Route path='/home' element={<Home />} />
//         <Route path='/register' element={<Registraction />} />
//         <Route path='/dashboard' element={<DashBoard />} />
//         <Route path='/' element={<Login />} />
//         <Route path='/fetch-user' element={<FetchData />} />
//       </Route>
//     )
//   )

//   return (
//     <>
//       <RouterProvider router={router} />
//     </>
//   );
// }

// export default App;


// // localStorage.setItem('formData', JSON.stringify([...formData, user]));


import { BrowserRouter, RouterProvider, createRoutesFromElements } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout/Layout';
import Home from './components/Home/Home';
import Registraction from './components/RegistrationPage/Registraction';
import DashBoard from './components/DashBoard/DashBoard';
import Login from './components/RegistrationPage/Login';
import FetchData from './components/FetchData/FetchData';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Referal from './components/UserReferal/Referal';

const App = () => {
  return (
    <Router basename='/GainApex2'>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="/home" element={<Home />} />
          <Route path="/Register" element={<Registraction />} />
          <Route path="/dashboard" element={<DashBoard />} />
          <Route path="/fetch-user" element={<FetchData />} />
          {/* Use a dynamic segment for referral code */}
          <Route path="/Register/:userReferralCode" element={<Registraction />} />
          <Route path="/dashboard/:userId" element={<DashBoard />} />
          {/* Default login route */}
          {/* <Route path="/" element={<Login />} /> */}
          <Route path="/" element={<Registraction />} />

        </Route>
          <Route path="/referal" element={<Referal />} />
      </Routes>
    </Router>
  );
};

export default App;


// function App() {
//   return (
//     <>
//       <BrowserRouter>
//         <Routes>
//           <Route path='/' element={<Layout />} >
//           <Route path='/home' element={<Home />} />
//           <Route path='/register' element={<Registraction />} />
//           <Route path='/dashboard' element={<DashBoard />} />
//           <Route path='/' element={<Login  />} />
//           <Route path='/fetch-user' element={<FetchData />} />
//           </Route>
//         </Routes>
//       </BrowserRouter>
//     </>
//   );
// }

// export default App;


// localStorage.setItem('formData', JSON.stringify([...formData, user]));